"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const lodash_1 = __importDefault(require("lodash"));
class DynamoDbTable {
    constructor(tableName, paramsOverride) {
        this.tableName = tableName;
        this.dbClient = new client_dynamodb_1.DynamoDBClient(paramsOverride || {});
        const translateConfig = { marshallOptions: { removeUndefinedValues: true } };
        this.docClient = lib_dynamodb_1.DynamoDBDocument.from(this.dbClient, translateConfig);
    }
    async get(keyObj) {
        const getParams = {
            TableName: this.tableName,
            Key: keyObj
        };
        const data = await this.docClient.get(getParams);
        return data.Item;
    }
    async put(item) {
        const putParams = {
            TableName: this.tableName,
            Item: item
        };
        return this.docClient.put(putParams);
    }
    static createUpdateParams(keyObj, item) {
        const itemNoKey = lodash_1.default.omit(item, Object.keys(keyObj));
        const keys = Object.keys(itemNoKey);
        const entries = Object.entries(itemNoKey);
        return {
            UpdateExpression: `set ${keys.map((k) => `#${k} = :${k}`).join(', ')}`,
            ExpressionAttributeNames: entries.reduce((acc, cur) => ({ ...acc, [`#${cur[0]}`]: cur[0] }), {}),
            ExpressionAttributeValues: entries.reduce((acc, cur) => ({ ...acc, [`:${cur[0]}`]: cur[1] }), {})
        };
    }
    async update(keyObj, item) {
        const updateParams = {
            TableName: this.tableName,
            Key: keyObj,
            ...DynamoDbTable.createUpdateParams(keyObj, item)
        };
        return this.docClient.update(updateParams);
    }
    async delete(keyObj) {
        const deleteParams = {
            TableName: this.tableName,
            Key: keyObj
        };
        return this.docClient.delete(deleteParams);
    }
    async query(params) {
        const queryParams = {
            TableName: this.tableName,
            ...params
        };
        const res = await this.docClient.query(queryParams);
        return res.Items;
    }
    async batchGet(itemsKeyObj) {
        const batchGetParams = {
            RequestItems: {
                [this.tableName]: {
                    Keys: itemsKeyObj
                }
            }
        };
        const res = await this.docClient.batchGet(batchGetParams);
        return lodash_1.default.get(res, ['Responses', this.tableName]);
    }
    async batchPut(items) {
        const batchPutParams = {
            RequestItems: {
                [this.tableName]: items.map((item) => ({
                    PutRequest: {
                        Item: item
                    }
                }))
            }
        };
        return this.docClient.batchWrite(batchPutParams);
    }
    async batchDelete(itemsKeyObj) {
        const batchDeleteParams = {
            RequestItems: {
                [this.tableName]: itemsKeyObj.map((itemKeyObj) => ({
                    DeleteRequest: {
                        Key: itemKeyObj
                    }
                }))
            }
        };
        return this.docClient.batchWrite(batchDeleteParams);
    }
    async describeTable() {
        return this.dbClient.send(new client_dynamodb_1.DescribeTableCommand({ TableName: this.tableName }));
    }
    async verifyTableExistsOrThrow() {
        try {
            await this.describeTable();
        }
        catch (e) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (e.name === 'ResourceNotFoundException') {
                throw new Error(`Table ${this.tableName} not found`);
            }
            else {
                throw e;
            }
        }
    }
}
exports.default = DynamoDbTable;
